import { FaSort, FaDownload, FaAlignRight } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from '../Detalles/SesionDetalles';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, LabelList } from 'recharts';
import { useAppState } from './GraficoContext';
import { apiFetch } from '../apiClient';

let filterregrescarFiltros = 0;

interface SumaGrupoEdad {
    totalPoblacion?: number;
    primeraInfancia05Anios?: number;
    infancia611Anios?: number;
    adolescencia1217?: number;
    juventud1828?: number;
    adultez2959?: number;
    personaMayor60?: number;
}


interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    indicador: any
}

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const GrupoEdad: React.FC<BarraProps> = ({ filtrar, codigoDivipola, indicador }) => {
    const { tieneGrupoEdad, setTieneGrupoEdad } = useAppState();
    const [sumaGrupoEdad, setdivipolaCantidad] = useState<SumaGrupoEdad>();
    const [cantidadNacional, setCantidadNacional] = useState<number>(0);
    let cargado = false;
    const fetchDatos = async () => {
        try {
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetSumaGrupoEdad?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            const cantidadNacionalNuevo = 0;
            cargado = true;
            setCantidadNacional(cantidadNacionalNuevo);
            setdivipolaCantidad(data);
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.regrescarFiltros != filterregrescarFiltros) {
            filterregrescarFiltros = DEFAULT_FILTER.regrescarFiltros;
            if (indicador != "") {
                fetchDatos();
            }
        }
    }

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, indicador]);

    const total = sumaGrupoEdad?.totalPoblacion || 0;
    const primeraInfancia05AniosPorcentaje = ((sumaGrupoEdad?.primeraInfancia05Anios || 0) / total) * 100;
    const infancia611AniosPorcentaje = ((sumaGrupoEdad?.infancia611Anios || 0) / total) * 100;
    const adolescencia1217Porcentaje = ((sumaGrupoEdad?.adolescencia1217 || 0) / total) * 100;
    const juventud1828Porcentaje = ((sumaGrupoEdad?.juventud1828 || 0) / total) * 100;
    const adultez2959Porcentaje = ((sumaGrupoEdad?.adultez2959 || 0) / total) * 100;
    const personaMayor60Porcentaje = ((sumaGrupoEdad?.personaMayor60 || 0) / total) * 100;
    const grupoEdadValues = [
        sumaGrupoEdad?.primeraInfancia05Anios,
        sumaGrupoEdad?.infancia611Anios,
        sumaGrupoEdad?.adolescencia1217,
        sumaGrupoEdad?.juventud1828,
        sumaGrupoEdad?.adultez2959,
        sumaGrupoEdad?.personaMayor60
    ];
    const allNull = grupoEdadValues.every(v => v == null);
    const totalGrupoEdad = allNull
        ? null
        : grupoEdadValues.reduce((acc: number, v) => acc + (v || 0), 0);
    let maximo = Math.max(sumaGrupoEdad?.primeraInfancia05Anios || 0, sumaGrupoEdad?.infancia611Anios || 0, sumaGrupoEdad?.adolescencia1217 || 0, sumaGrupoEdad?.juventud1828 || 0, sumaGrupoEdad?.adultez2959 || 0, sumaGrupoEdad?.personaMayor60 || 0);
    maximo = maximo + (maximo * 0.1);

    useEffect(() => {
        if (isNaN(totalGrupoEdad ?? NaN)) {
            setTieneGrupoEdad(false);
        } else {
            setTieneGrupoEdad(true);
        }
    }, [totalGrupoEdad, setTieneGrupoEdad]);

    if (isNaN(totalGrupoEdad ?? NaN)) {
        return <div style={{ float: "left" }}></div>;
    }
    return (
        <div style={{ alignItems: 'center', backgroundColor: '#fff', borderTop: '1px solid #ccc', float: 'left', margin: '10px 10px 0px 10px', padding: '10px 0px 0px 10px', width: '600px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: '220px' }}>
            <table style={{ width: '100%', maxHeight: 220 }}>
                <tbody>
                    <tr>
                        <td style={{ width: '120px', textAlign: 'left', verticalAlign: "TOP" }}>
                            <h3 style={{ color: "#2c66a4", fontWeight: 'bold' }}>Ciclo de Vida</h3><br />
                            <div style={{ paddingLeft: "20px" }}>
                                Total<br />
                                <b>{formatNumber(totalGrupoEdad || 0)}</b>
                            </div>
                        </td>
                        <td style={{ textAlign: 'center', paddingTop: "20px" }}>
                            <BarChart width={480} height={180} data={sumaGrupoEdad ? [
                                { name: 'Primera Infancia', Cantidad: sumaGrupoEdad.primeraInfancia05Anios || 0 },
                                { name: 'Infancia', Cantidad: sumaGrupoEdad.infancia611Anios || 0 },
                                { name: 'Adolescencia', Cantidad: sumaGrupoEdad.adolescencia1217 || 0 },
                                { name: 'Juventud', Cantidad: sumaGrupoEdad.juventud1828 || 0 },
                                { name: 'Adultez', Cantidad: sumaGrupoEdad.adultez2959 || 0 },
                                { name: 'Persona Mayor', Cantidad: sumaGrupoEdad.personaMayor60 || 0 }
                            ] : []}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                                <YAxis tick={{ fontSize: 10 }} domain={[0, maximo]} tickFormatter={(value) => formatNumber(Math.round(value))} />
                                <Tooltip formatter={(Cantidad: number) => formatNumber(Cantidad)} />
                                <Bar dataKey="Cantidad" fill="#88C4B3" style={{ paddingTop: '10px' }} >
                                    {sumaGrupoEdad && Object.keys(sumaGrupoEdad).map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill="#88C4B3" />
                                    ))}
                                    <LabelList dataKey="Cantidad" position="top" formatter={(Cantidad: number) => formatNumber(Cantidad)} style={{ fontSize: '8px' }} />
                                </Bar>
                            </BarChart>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    );

};

export default GrupoEdad;